export class UnsavedCar {
    year: number;
    make: string;
    model: string;
    mileage: string;

    constructor(year = null, make = null, model = null, mileage = null) {
        this.year = year;
        this.make = make;
        this.model = model;
        this.mileage = mileage;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/unsavedCar.ts